module.exports = __webpack_public_path__ + "static/media/AAMGA.ace7075b.png";